<template>
  <div class="serviceEvaluation-add">
    <van-row type="flex" justify="center" class="row-title">
      <van-col span="24" class="col-title">
        <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="friends-o">
          服务评价
        </van-notice-bar>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-tip">
      <van-col span="24" class="col-tip">
        <van-divider
          :style="{ color: '#999', borderColor: '#999', padding: '0 16px' }"
        >
          请输入您的意见
        </van-divider>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-form">
      <van-col span="23" class="col-from">
        <van-field
          v-model="ServiceObject"
          v-validate="{required:true}"
          readonly
          clickable
          name="picker"
          label="服务端"
          placeholder="点击选择服务端"
          :rules="[{ required: true, message: '请选择服务端' }]"
          @click="showServiceObjectPicker = true"
        />
        <van-popup v-model="showServiceObjectPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="allServiceObjectList"
            @confirm="onServiceObjectConfirm"
            @cancel="showServiceObjectPicker = false"
          />
        </van-popup>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-form">
      <van-col span="23" class="col-from">
        <van-field
          v-model="EvaluationItems"
          v-validate="{required:true}"
          readonly
          clickable
          name="picker"
          label="评价事项"
          placeholder="点击选择评价事项"
          :rules="[{ required: true, message: '请选择评价事项' }]"
          @click="showEvaluationItemsPicker = true"
        />
        <van-popup v-model="showEvaluationItemsPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="allEvaluationItemsList"
            @confirm="onEvaluationItemsConfirm"
            @cancel="showEvaluationItemsPicker = false"
          />
        </van-popup>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-form">
      <van-col span="23" class="col-from">
        <van-field
          v-model="InteractType"
          v-validate="{required:true}"
          readonly
          clickable
          name="picker"
          label="互动类型"
          placeholder="点击选择互动类型"
          :rules="[{ required: true, message: '请选择互动类型' }]"
          @click="showInteractTypePicker = true"
        />
        <van-popup v-model="showInteractTypePicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="allInteractTypeList"
            @confirm="onInteractTypeConfirm"
            @cancel="showInteractTypePicker = false"
          />
        </van-popup>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-form">
      <van-col span="7" class="col-from van-cell van-cell--clickable van-field">
        <div class="van-cell__title van-field__label"><span style="font-size:15px">服务评分</span></div>
      </van-col>
      <van-col span="16" class="col-from">
        <van-rate
          v-model="Score"
          :size="25"
          color="#ee0a24"
          void-icon="star"
          void-color="#c7c7c7"
        />
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-form">
      </van-col>
      <van-col span="23" class="col-from">
        <van-cell-group>
          <van-field
            v-model="Content"
            label="内容"
            type="textarea"
            placeholder="请输入内容"
            rows="8"
            autosize
          />
        </van-cell-group> 
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-button">
      <van-col span="22" class="col-button">
        <van-button round block type="info" native-type="submit" @click="handleSubmit()">
          确认提交
        </van-button>
      </van-col>
    </van-row>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex'
import { Notify, Toast, Uploader, Rate } from 'vant'
import { addServiceEvaluation } from '@/api/deletate'

import Vue from 'vue'
Vue.use(Rate)

const qs = require('qs')
const url = require('url')

export default {
  components: {},
  data() {
    return {
      Score: 0,
      ServiceObject: '',
      EvaluationItems: '',
      InteractType: '',
      allServiceObjectList: [{ key: '0', text: '个人', value: '0' }, { key: '1', text: '企业', value: '1' }],
      allEvaluationItemsList: [{ key: '0', text: '业务办理', value: '0' }],
      allInteractTypeList: [{ key: '0', text: '服务评价', value: '0' }, { key: '1', text: '投诉建议', value: '1' }],
      serviceEvaluation: {
        UserId: '',
        Name: '',
        ServiceObject: '',
        EvaluationItems: '',
        InteractType: '',
        Score: '',
        Content: ''
      },
      showServiceObjectPicker: false,
      showEvaluationItemsPicker: false,
      showInteractTypePicker: false,
      Content: ''
    }
  },
  computed: {
    ...mapGetters(['webUserInfo'])
  },
  mounted() {
    // 获取url对象
    const urlObj = url.parse(window.location.href)
    console.log(urlObj)
    if (urlObj.query === null) {
      this.serviceEvaluation.Name = this.webUserInfo.realName
      this.serviceEvaluation.UserId = this.webUserInfo.id
    } else {
      // 获取查询对象
      this.serviceEvaluation.Name = this.webUserInfo.realName
      this.serviceEvaluation.UserId = this.webUserInfo.id
    }
  },
  methods: {
    onServiceObjectConfirm(ServiceObject) {
      Toast(ServiceObject.text)
      this.showServiceObjectPicker = false
      this.ServiceObject = ServiceObject.text
      this.serviceEvaluation.ServiceObject = ServiceObject.value
    },
    onEvaluationItemsConfirm(EvaluationItems) {
      Toast(EvaluationItems.text)
      this.showEvaluationItemsPicker = false
      this.EvaluationItems = EvaluationItems.text
      this.serviceEvaluation.EvaluationItems = EvaluationItems.value
    },
    onInteractTypeConfirm(InteractType) {
      Toast(InteractType.text)
      this.showInteractTypePicker = false
      this.InteractType = InteractType.text
      this.serviceEvaluation.InteractType = InteractType.value
    },
    handleSubmit() {
      if (!this.serviceEvaluation.InteractType || !this.serviceEvaluation.EvaluationItems || !this.serviceEvaluation.ServiceObject || !this.Content) {
        Toast.fail('内容不能为空')
        Notify({ type: 'danger', message: '请填写完整评价信息' })
        return
      }
      this.serviceEvaluation.Score = this.Score
      this.serviceEvaluation.Content = this.Content
      console.info(this.serviceEvaluation)
      addServiceEvaluation(this.serviceEvaluation)
        .then(response => {
            Notify({ type: 'success', message: '服务评价操作成功！' })
                Toast.clear()
                setTimeout(() => {
                  // 跳转页面
                  this.$router.push({
                    path: '/'
                  })
                }, 1000)          })
        .catch(error => {
          Notify({ type: 'danger', message: '服务评价操作失败！' })
        })
    },
   }
}
</script>

<style lang="scss" scoped>
  .serviceEvaluation-add{
    min-height: 100vh;
    background-color: #F1F0F8;
    .col-tip{
      p{
        margin-left: 5px;
        font-weight: bold;
        font-size: 0.8em;
      }
    };
    .row-button{
      margin-top: 20px;
    }
    .row-show{
      margin-top: 16px;
      .col-show{
        .reser-content{
          padding: 5px 0;
          p{
            margin: 0 16px 0;
            font-size: 0.8em;
            color: #666;
          }
        }
      }
    }
    .row-button{
      margin-top: 50px;
    }
  }
